import * as React from 'react';
import { Link, useNavigate } from 'react-router';
import { TCategoryRow } from './CategoryRow.types';
import './CategoryRow.styled.scss';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

export const CategoryRow: TCategoryRow = ({
  category,
  isSelected,
  onMouseEnter,
  onMouseLeave,
  onCategoryClick,
}) => {
  const navigate = useNavigate();
  const localize = useLocalize();
  const categoryUrl = `/${category.id}`;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(categoryUrl);
    if (onCategoryClick) {
      onCategoryClick();
    }
  };

  return (
    <Link
      to={categoryUrl}
      className={`category-row ${isSelected ? 'category-row--selected' : ''}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleClick}
    >
      {localize(category.nameKey)}
    </Link>
  );
};
